import { defineMessages } from "@/i18n";
import en from "./en";

export const inputBarPickersMessages = defineMessages("input-bar-pickers", en);
